<template>
    <ul class="list description-list" :class="[sizeString ? 'list-' + sizeString : '', {'description-list--right' : alignRight}]" :style="{maxWidth: `${maxWidth}px`}">
        <slot/>
    </ul>
</template>

<script>
import ListMixin from "../ListMixin";

    export default {
        name: "DescriptionList",

        mixins: [ListMixin],

        props: {
            maxWidth: {
                type: [Number, String],
                default: 900
            },

            // Whether to align the text on the right even on desktop devices
            alignRight: {
                type: Boolean,
                default: false
            }
        }
    }
</script>
<style>
/*********************
  Inputs
**********************/
.description-list + .description-list {
  border-top: 1px solid #e6ecf5;
  padding-top: 16px;
  margin-top: 16px;
}
</style>